import { ValueGetterParams } from 'ag-grid-community';
import { EXTRA_DETAILS } from 'constant';
import { Field } from 'stores/fields';
import { getBaseValueGetter } from 'utils/value-getter/base-value-getter';
import { SourceType } from './fields';

interface ValueGetter {
  (params: ValueGetterParams): any;
}

export const getValueGetter = (
  field: Pick<Field, 'type' | 'fieldName' | 'sourceType' | 'fieldId'>,
): ValueGetter | undefined => {
  if (field.sourceType !== SourceType.Task) {
    return ({ data }) => {
      return data?.[EXTRA_DETAILS][field.sourceType]?.[field.fieldName];
    };
  }

  return getBaseValueGetter(field);
};
